import { NgModule } from '@angular/core';

import { WysiwygInlineButtonModule } from '../../wysiwyg-inline-button/wysiwyg-inline-button.module';
import { WysiwygLinkComponent } from './wysiwyg-link.component';

@NgModule({
  imports: [WysiwygInlineButtonModule],
  declarations: [WysiwygLinkComponent],
  exports: [WysiwygLinkComponent],
})
export class WysiwygLinkModule {}
export { WysiwygLinkComponent } from './wysiwyg-link.component';
